var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUganda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9434 20C22.8439 17.8769 24 15.0737 24 12C24 8.92635 22.8438 6.12309 20.9434 4.00002L12 3.13049L3.05662 4.00002C1.15617 6.12309 0 8.92635 0 12C0 15.0737 1.15613 17.8769 3.05658 20L12 20.8696L20.9434 20Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.05664 3.99998H20.9434C18.7462 1.54528 15.5538 0 12 0C8.44628 0 5.25386 1.54528 3.05664 3.99998Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 12L12 13.0435L24 12C24 10.5973 23.7585 9.25119 23.3162 8H0.683812C0.241453 9.25119 0 10.5973 0 12H0Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.683812 16H23.3163C23.7585 14.7488 24 13.4027 24 12H0C0 13.4027 0.241453 14.7488 0.683812 16Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9435 20H3.05664C5.25386 22.4548 8.44628 24 12.0001 24C15.5538 24 18.7463 22.4548 20.9435 20Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0048 11.9999C16.0048 14.2117 14.2121 16.0043 12.0004 16.0043C9.78873 16.0043 7.99609 14.2117 7.99609 11.9999C7.99609 9.78825 9.78873 7.99561 12.0004 7.99561C14.2121 7.99561 16.0048 9.78825 16.0048 11.9999Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4669 12.2041L11.9999 11.5685C11.9999 11.5685 12.3431 10.4293 12.3614 10.3513C12.3748 10.2943 12.3819 10.235 12.3819 10.1739C12.3819 9.95779 12.2943 9.76213 12.1526 9.62057L12.5215 9.25166C12.2855 9.01564 11.9594 8.86963 11.5992 8.86963C11.239 8.86963 10.9129 9.0156 10.6769 9.25166L11.0458 9.62057C10.9042 9.76218 10.8166 9.95783 10.8166 10.1739C10.8166 10.253 10.8285 10.3291 10.8503 10.4011L10.2949 10.9565H11.3044C11.3044 10.9565 10.887 11.5834 10.6592 12.0982C10.4313 12.613 10.6623 13.2414 11.1889 13.4755L11.4934 13.6108L11.9999 14.0869V14.6086L11.4782 15.1303H12.5217V14.0869L12.9978 13.6108H13.9825C13.9873 13.601 13.9922 13.5914 13.9967 13.5814C14.2307 13.0548 13.9935 12.4381 13.4669 12.2041Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/67023026.svg";
export { SvgUganda as ReactComponent };